'use client';
import React from 'react';
import { TasticProps } from '../types';
import LandingPageBanner from '@/components/organisms/landing-page-banner';
import { Props } from '../blog/types';

const LandingPageTastic = ({ data }: TasticProps<Props>) => {

    return (
        <LandingPageBanner data={data}/>
    );
};

export default LandingPageTastic;
